export default __webpack_public_path__ + "static/media/AustinOBrien.28089a3a.jpg";